/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-segmented-control-radio .segmented-control{margin-top:0}.title[_ngcontent-%COMP%]{margin:0}.schedule__wrapper[_ngcontent-%COMP%]{margin:1rem 0 2rem}.direct-flights__wrapper[_ngcontent-%COMP%]{margin-bottom:2rem}.route-title[_ngcontent-%COMP%]{text-transform:uppercase;font-size:1.4rem;font-weight:700;font-family:\"GT Flexa\",Arial,Helvetica,sans-serif}.ticket-options__wrapper[_ngcontent-%COMP%]{margin:1.5rem 0 2rem}.airlines__wrapper[_ngcontent-%COMP%]{margin:1rem 0}"];
export { styles as styles };
